// extracted by mini-css-extract-plugin
export default {"version__text":"Version_version__text__4H5+o"};